import { createGetService } from '@ligo/shared/utils';
import { Company } from '@ligo/dashboard/store';
import { RESOURCES } from '../resources';

export const CompanyService = createGetService<Company>(RESOURCES.COMPANIES);
